import TableHeadToolbar from "../../TableHeadToolbar";
import { TableHeadActiveProps } from "./types";

const TableHeadActive = ({ toggleActiveHead }: TableHeadActiveProps) => {
    return <TableHeadToolbar toggleActiveHead={toggleActiveHead} />;
};

export default TableHeadActive;
